import { useState } from "react";
import { Box, Card, Typography, Chip, IconButton } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import OpenInNewOutlinedIcon from '@mui/icons-material/OpenInNewOutlined';
import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown';
import { Icon } from '@iconify/react';

const TreeView = ({ parent, child = [], subChild = [], onFillServiceClick }) => {

    const finalTree = [
        {
            ...parent,
            Children: child.map((c) => ({
                ...c,
                Children: subChild.filter(sc => sc.ParentChildId === c.Id)
            }))
        }
    ];

    const getPriorityStyle = (priority) => {
        switch ((priority || "").toLowerCase()) {
            case "high":
                return { bg: "#FFE2E2", color: "#9F0712" };
            case "medium":
                return { bg: "#FEF9C2", color: "#9A6B00" };
            default:
                return { bg: "#E3F2FD", color: "#3976D2" };
        }
    };

    const getLeftOffset = (level) => {
        if (level === 0) return 60;
        if (level === 1) return 70;
        return 70;
    };
    const getIdColor = (level) => {
        if (level === 0) return "#FC3838";   // Parent
        if (level === 1) return "#FC9A38";   // Child
        return "#00A63E";                    // Sub Child
    };

    // ⭐ ADD INDEX HERE ⭐
    const Node = ({ item, level, childList, isLast, index = 0,  }) => {
        const [open, setOpen] = useState(true);
        const priorityStyle = getPriorityStyle(item.Priority);
        const leftOffset = getLeftOffset(level);
        const isParent = level === 1;   

        return (
            <Box position="relative" sx={{ paddingLeft: level === 0 ? "0px" : "28px" }}>
                {/* LEFT VERTICAL LINE */}
                {/* LEFT VERTICAL LINE */}
                {level > 0 && (
                    <Box
                        sx={{
                            position: "absolute",
                            left: 18,
                            top: -15,
                            bottom: 0,
                            width: "2px",
                            bgcolor: "#D8D8D8",
                        }}
                    />
                )}

                {/* HORIZONTAL LINE */}
                {level > 0 && (
                    <Box
                        sx={{
                            position: "absolute",
                            left: 18,
                            top: 50,
                            height: "2px",
                            width: level === 1 ? "36px" : "26px",
                            bgcolor: "#D8D8D8",
                        }}
                    />
                )}

                <Card
                    sx={{
                        p: 2,
                        borderRadius: "14px",
                        boxShadow: "0px 4px 12px rgba(0,0,0,0.10)",
                        mt: level === 0 ? 0 : 2,
                    }}
                >
                    <Box display="flex" alignItems="center" gap={1}>

                        {/* Toggle */}
                       
                        {/* ⭐ UPDATED LABEL HERE ⭐ */}
                        <Chip
                            label={
                                level === 0
                                    ? "Parent"
                                    : `Child - ${index + 1}`  // child and subchild both
                            }
                            size="small"
                            sx={{
                                height: "20px",
                                borderRadius: "6px",
                                backgroundColor: level === 0 ? "#2B7FFF" : "#FFFFFF",
                                color: level === 0 ? "#FFFFFF" : "#ABABAB",
                                border: level === 0 ? "none" : "1px solid #EBEBEB",
                                fontWeight: 600,
                                fontSize: "11px"
                            }}
                        />

                        <Typography sx={{ color: getIdColor(level), fontWeight: 600, fontSize: "12px" }}>
                            {item.Id}
                        </Typography>

                        <Typography sx={{ fontSize: "12px", color: "#595757", fontWeight: 500 }}>
                            {item.ProjectVersionName || item.Client} :{" "}
                            {item.IssueCategory_LastRemark || item.IssueCategory}
                        </Typography>

                        <Chip
                            label={item.Priority}
                            size="small"
                            sx={{
                                bgcolor: priorityStyle.bg,
                                color: priorityStyle.color,
                                height: "22px",
                                fontSize: "10px",
                                fontWeight: 500
                            }}
                        />
                        {childList?.length > 0 && (
                            <Box display="flex" alignItems="center" ml="auto" gap={0.5}>
                                <Icon
                                    icon="material-symbols:graph-1"
                                    width="15"
                                    height="15"
                                    style={{ color: "#8D8B8B" }}
                                />
                                <Typography sx={{ fontSize: "12px", fontWeight: 400, color: "#8D8B8B" }}>
                                    {childList?.length || 0} Child
                                </Typography>
                                {isParent && (
                                    <Chip
                                        size="small"
                                        clickable
                                        onClick={() => setOpen(!open)}
                                        label={
                                            <KeyboardArrowDown
                                                sx={{
                                                    fontSize: 13,
                                                    transform: open ? "rotate(180deg)" : "rotate(0deg)",
                                                    transition: "0.2s",
                                                    color: "#FFFFFF"  // icon white for visibility
                                                }}
                                            />
                                        }
                                        sx={{
                                            height: 15,
                                            bgcolor: "#121212",
                                            borderRadius: "7px",
                                            width: 19,
                                            "& .MuiChip-label": {
                                                padding: 0,
                                                display: "flex",
                                                alignItems: "center",
                                            },
                                            "&:hover": {
                                                backgroundColor: "#121212",   // SAME COLOR AS NORMAL
                                            }
                                        }}
                                    />
                                )}
                            </Box>
                        )}
                    </Box>

                    <Box display="flex" mt={1}>
                        <Box sx={{ width: leftOffset }} />
                        <Typography sx={{ fontSize: "12px", color: "#716F6F", fontWeight: 400 }} dangerouslySetInnerHTML={{
                            __html: (item.Remarks || "").replace(/\n/g, "<br/>"),
                        }}/>
                           
                    </Box>

                    <Box display="flex" mt={1} alignItems="center">
                        <Box sx={{ width: leftOffset }} />
                        <CalendarMonthOutlinedIcon sx={{ color: "#4A5565", mr: 1, width: 16, height: 16, }} />

                        <Typography sx={{ fontSize: "12px", mr: 3, fontWeight: 400, color:'#4A5565' }}>
                            {item.Date1 || item.Date}
                        </Typography>

                        <Box display="flex" alignItems="center" onClick={() => onFillServiceClick?.(item)} >
                            <Typography sx={{ color: "#0077FF", fontWeight: 500, cursor: "pointer", fontSize: "12px", mr: 1 }} >
                                Fill Service
                            </Typography>
                            <OpenInNewOutlinedIcon sx={{ color: "#0077FF", width: 13, height: 13, }} />

                        </Box>

                    </Box>
                </Card>

                {/* RECURSION */}
                {open &&
                    childList?.map((child, childIndex) => (
                        <Node
                            key={child.Id}
                            item={child}
                            level={level + 1}
                            childList={child.Children}
                            index={childIndex}      // ⭐ ADDED
                            isLast={childIndex === childList.length - 1}
                        />
                    ))}
            </Box>
        );
    };

    return (
        <Box py={1}>
            {finalTree.map((root, rootIndex) => (
                <Node
                    key={root.Id}
                    item={root}
                    level={0}
                    index={rootIndex}     // ⭐ ADDED
                    childList={root.Children}
                    isLast
                    onFillServiceClick={onFillServiceClick}
                />
            ))}
        </Box>
    );
};

export default TreeView;
